// removed by extract-text-webpack-plugin
module.exports = {"xl":"size__xl___3dV9V marginRight-xl","l":"size__l___20gHX marginRight-l","m":"size__m___3OOcA marginRight-m","s":"size__s___3e9ei marginRight-s","xs":"size__xs___1JOKe marginRight-xs","xxs":"size__xxs___1aKEI marginRight-xxs","none":"size__none___XHI34 margin-0"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/size.css
// module id = 13
// module chunks = 0 1 2 3 6